<template>
  <div
    :class="{ 'w-table-unit w-table-module enable-scrolling': true, 'with-error': hasError }"
    @dblclick="activate"
  >
    <w-row
      v-if="!noHeader"
      no-gutters
      class="w-unit__header"
    >
      <WorkUnitPrependHeader
        v-model="showContentOnXs"
        :show-toggle-visibility="showToggleVisibility"
        :content-class="getIsArrowClass()"
      />
      <w-column>
        <h4 v-if="title || showToggleVisibility">
          {{ title }}
        </h4>
      </w-column>
      <v-spacer />
      <w-column
        v-if="showHeaderAppend"
        cols="auto"
        class="d-flex align-center justify-end"
      >
        <w-row
          no-gutters
          class="w-unit__header__append"
        >
          <slot
            name="header-append"
            :readonly="_readOnly"
          />
        </w-row>
      </w-column>
    </w-row>
    <v-container
      v-if="$scopedSlots.filter"
      :class="{
        'w-unit__content': true,
        'w-unit__content--no-header': noHeader,
      }"
      fluid
    >
      <slot
        name="filter"
        :readonly="_readOnly"
      />
    </v-container>
    <v-container
      v-show="isUnitContentVisible"
      class="pa-0 w-unit__content scrollable-data"
      fluid
    >
      <slot
        name="table"
        :readonly="_readOnly"
      />
    </v-container>
  </div>
</template>

<script>
import workUnitMixin from './work-unit-mixin';
import workUnitMobileMixin from './work-unit-mobile-mixin';
import WorkUnitPrependHeader from './WorkUnitPrependHeader';
import mobileFilterMixin from '@/components/base_components/tables/filter/mobile-filter-mixin';

export default {
  name: 'WorkTableUnit',
  components: {
    WorkUnitPrependHeader,
  },
  mixins: [workUnitMixin, workUnitMobileMixin, mobileFilterMixin],
  props: {
    id: String,
    title: String,
    noHeader: Boolean,
    hasError: { type: Boolean, default: false },
  },
  computed: {
    panelCollapseOnXS() {
      if (this.$vuetify.breakpoint.xsOnly) return;
      else return 0;
    },
  },
};
</script>

<style lang="scss">
@import 'src/components/global_components/unit/WUnit';

.enable-scrolling:not(.w-divided-in .enable-scrolling) {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.scrollable-data {
  overflow: auto;
}

</style>
